<!-- HEADER -->
<header id="main-header" class="py-2 bg-info text-white">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h1>
            <i class="fa fa-user-circle" aria-hidden="true"></i> Sub-admins
          </h1>
        </div>
      </div>
    </div>
  </header>
  
  <!-- SEARCH -->
  <section id="search" class="py-4 mb-4 bg-light">
    <div class="container">
      <div class="row">
        <div class="col-md-6 ml-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search Sub-admin...">
            <div class="input-group-append">
              <button class="btn btn-info">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- SESSIONS -->
  <section id="sessions">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-header text-center">
              <h4>All Sub-admins</h4>
            </div>
            <table class="table table-striped text-center">
              <thead class="thead-dark">
                <tr>
                  <!-- <th>#</th> -->
                  <th>Name</th>
                  <th>Password/Code</th>
                  <th>Contact</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let subAdmin of subAdminList">
                  <!-- <td></td> -->
                  <td>{{ subAdmin.name }}</td>
                  <td>{{ subAdmin.password }}</td>
                  <td>{{ subAdmin.mobileNumber }}</td>
                  <td>
                    <a class="btn btn-info text-white" (click)="onSubAdminDetails(subAdmin._id)" data-toggle="modal" data-target="#subAdminDetailsModal">
                      <i class="fas fa-angle-double-right"></i> Details
                    </a>
                  </td>
                  <td>
                    <a class="btn btn-info text-white" data-toggle="modal" data-target="#allotSessionsModals" (click)="onAllotSessions(subAdmin._id)">
                      <i class="fas fa-sort-amount-down"></i> Allot Sessions
                    </a>
                  </td>
                </tr>
  
              </tbody>
            </table>
  
            <!-- PAGINATION -->
            <!-- <nav class="ml-4">
              <ul class="pagination">
                <li class="page-item disabled">
                  <a href="#" class="page-link">Previous</a>
                </li>
                <li class="page-item active">
                  <a href="#" class="page-link">1</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">2</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">3</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">Next</a>
                </li>
              </ul>
            </nav> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  
  
  <!-- Sub-admin Details Modal -->
  <div class="modal fade" id="subAdminDetailsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-info text-white">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ selectedSubAdmin.name }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Email :</b>
            </div>
            <div class="col-7">
              {{ selectedSubAdmin.email }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Password/Code :</b>
            </div>
            <div class="col-7">
              {{ selectedSubAdmin.password }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Qualification :</b>
            </div>
            <div class="col-7">
              {{ selectedSubAdmin.qualification }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Contact :</b>
            </div>
            <div class="col-7">
              {{ selectedSubAdmin.mobileNumber }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Location :</b>
            </div>
            <div class="col-7">
              {{ selectedSubAdmin.location }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="onDeleteSubAdmin(selectedSubAdmin._id)">Remove {{ selectedSubAdmin.name }}</button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Allot sessions Modal -->
  <div class="modal fade" id="allotSessionsModals" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-info text-white">
          <h5 class="modal-title" id="exampleModalLongTitle">Allot sessions to {{ selectedSubAdmin.name }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row text-center my-2" *ngFor="let session of sessionList">
            <!-- <div class="col">
              <input #checkboxes class="form-check-input" type="checkbox" value="Tutor 1" id="flexCheckDefault" (click)="onChecked(session._id)">
            </div> -->
            <div class="col">
              {{ session.sessionCode }}
            </div>
            <div class="col">
              {{ session.sessionTopic }}
            </div>
            <div class="col">
              Date and Time
            </div>
            <div class="col">
              {{ session.status }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-info" data-dismiss="modal" (click)="onSaveChanges()">Save Changes</button>
        </div>
      </div>
    </div>
  </div>
  